/* eslint-disable no-console */
import type { BlockComponentProps } from 'client-react-block-renderer';
import React from 'react';
import MyProfileForm from './MyProfileForm.client';
import store from './app/store.client';
import { Provider } from 'react-redux';
import { getCurrentUserId } from '@rcm/current-user';
import t from '@rcm/i18n-client';

interface Props extends BlockComponentProps<BlockData, BlockConfig> {}

interface BlockConfig {}

interface BlockData {}

const MyProfileBlock = (props: Props) => {
  if (!getCurrentUserId()) return <div>{t('You must be logged in before you can use this page.')}</div>;

  return (
    <Provider store={store}>
      <MyProfileForm />
    </Provider>
  );
};
export default MyProfileBlock;
